// Universal red/teal asterisk marker for mandatory form fields.
// Placed after a label to signal "required" to the user. The community
// expectation is: * = mandatory; the word "(optional)" continues to be used
// for the reverse cue.
export function RequiredMark() {
    return (
        <span
            className="text-[#00A896] ml-0.5"
            aria-hidden="true"
            data-testid="req-asterisk"
            title="Required"
        >
            *
        </span>
    );
}

export default RequiredMark;
